import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { MapPinIcon, ShirtIcon } from 'lucide-react';
import { festivalDays, party } from '../data/party';
export function Schedule() {
  const [activeDayId, setActiveDayId] = useState(festivalDays[0].id);
  const activeDay = festivalDays.find(day => day.id === activeDayId) ?? festivalDays[0];
  return <section id="lineup" className="w-full bg-[var(--night)] px-5 py-24" data-id="element-137" data-mp="w5uibu0ajdkz">
      <div className="mx-auto max-w-4xl" data-id="element-138" data-mp="3ungldzzjkp4s">
        <div className="mb-10 text-center" data-id="element-139" data-mp="3f2q17mcj92x">
          <p className="font-poster mb-3 uppercase tracking-[0.3em] text-[var(--gold)]" data-id="element-140" data-mp="3funknzi7gvu">
            {party.dateLong} · {party.gates}
          </p>
          <h2 className="font-display text-5xl uppercase text-white sm:text-7xl" data-id="element-141" data-mp="dd8rxp85kf7s">Festival Lineup</h2>
        </div>

        <div role="tablist" aria-label="Kanchella weekend schedule" className="mx-auto mb-10 flex max-w-md rounded-full border border-white/15 bg-white/5 p-1" data-id="element-142" data-mp="1ju410n27jl7w">
          {festivalDays.map(day => {
          const isActive = day.id === activeDay.id;
          return <button key={day.id} id={`${day.id}-tab`} type="button" role="tab" aria-selected={isActive} aria-controls={`${day.id}-panel`} onClick={() => setActiveDayId(day.id)} className={`flex-1 rounded-full px-3 py-2 font-poster text-lg uppercase tracking-wide transition-colors focus:outline-none focus:ring-2 focus:ring-[var(--gold)] focus:ring-offset-2 focus:ring-offset-[var(--night)] ${isActive ? 'bg-[var(--gold)] text-[var(--night)]' : 'text-white/65 hover:text-white'}`} data-id="element-143" data-mp="1860039ebljt9">
                {day.label}
              </button>;
        })}
        </div>

        <div id={`${activeDay.id}-panel`} role="tabpanel" aria-labelledby={`${activeDay.id}-tab`} data-id="element-144" data-mp="bgin09d0cvhj">
          <p className="font-poster mb-6 text-center text-lg uppercase tracking-[0.28em] text-[var(--gold)]" data-id="element-145" data-mp="3sxd0hmibmqva">
            {activeDay.eyebrow}
          </p>

          <ol className="space-y-3" data-id="element-146" data-mp="1rttgwr9ffs4">
            {activeDay.items.map((item, i) => <motion.li key={`${activeDay.id}-${item.title}`} initial={{
            opacity: 0,
            x: -16
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            duration: 0.35,
            delay: i * 0.05
          }} className="flex flex-col gap-2 rounded-2xl border border-white/10 bg-white/[0.03] px-6 py-5 sm:flex-row sm:gap-6" data-id="element-147" data-mp="3j08nodad87r5" data-mpi={i}>
                <span className="font-poster shrink-0 text-xl text-[var(--gold)] sm:w-44 sm:text-2xl" data-id="element-148" data-mp="5tf92pv6i860">
                  {item.time}
                </span>
                <span className="flex-1" data-id="element-149" data-mp="apdsdz1ngzzk">
                  <span className="font-display block text-2xl uppercase leading-tight text-white" data-id="element-150" data-mp="yh2ozrli8amb">
                    {item.title}
                  </span>
                  {item.detail ? <span className="mt-1 block text-sm text-white/65" data-id="element-151" data-mp="2nxokc1kron9e">{item.detail}</span> : null}
                  <span className="mt-2 flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-white/50" data-id="element-152" data-mp="2iykbjc1r8rjl">
                    <span className="flex items-center gap-1.5" data-id="element-153" data-mp="2xnq8etd4e5ob">
                      <MapPinIcon className="h-3.5 w-3.5 text-[var(--gold)]" data-id="element-154" data-mp="2son4jc8vm5hx" />
                      {item.location}
                    </span>
                    {item.attire ? <span className="flex items-center gap-1.5" data-id="element-155" data-mp="200r7u7jb4dl5">
                        <ShirtIcon className="h-3.5 w-3.5 text-[var(--gold)]" data-id="element-156" data-mp="202c5i60x4cn8" />
                        Attire: {item.attire}
                      </span> : null}
                  </span>
                </span>
              </motion.li>)}
          </ol>

          {activeDay.footnote ? <p className="font-poster mt-6 text-center text-lg uppercase tracking-[0.2em] text-[var(--gold)]" data-id="element-157" data-mp="3pha37hjlzdkm">
              {activeDay.footnote}
            </p> : null}
        </div>
      </div>
    </section>;
}